import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';
import { StaticImageData } from 'next/image';
import { NationalBook, NationalSemibold, Tiempos } from 'fonts';
export interface WhyCaromaBannerProps {
  data: any;
}
type slideProps = {
  banner_desktop_image: { url: string | StaticImageData | undefined; title: string | undefined; description: string | undefined };
  content_alignment: string;
  banner_heading: string | undefined;
  banner_description: string | undefined;
  ctas: { title: string | undefined; href: string | Reference | undefined };
};
const WhyCaromaBanner: React.FC<WhyCaromaBannerProps> = ({ data }) => {
  const [isTabletSize] = useMediaQuery(tablet);

  return (
    <div className="relative w-full pt-72">
      {data?.banner_slider?.map((slide: any, index:number) => (
        <div key={index}>
          {slide?.banner_desktop_image?.url ? (
            <div className="relative h-[52rem] xl:h-[35rem] 2xl:h-[50rem]">
              <Image
                // {...image}
                // priority
                loading='lazy'
                src={isTabletSize ? slide?.banner_desktop_image?.url : slide?.banner_desktop_image?.url}
                //   loading="eager"
                alt={slide?.banner_desktop_image?.description}
                fill
                style={{ objectFit: 'cover' }}
                className="brightness-75"
              />
            </div>
          ) : (
            <div className=""></div>
          )}

          <div
            className={`absolute left-1/2 top-1/3 w-full -translate-x-1/2 -translate-y-1/2 transform px-24 lg:w-[47rem] lg:px-0 ${
              slide?.content_alignment === 'Center' ? 'text-center' : 'text-left'
            }`}
          >
            <Typography
              as="h1"
              className={`mt-200 pt-100 text-32 font-semibold leading-10 text-white drop-shadow-sm xl:mt-80 xl:pt-80 2xl:mt-120 2xl:pt-128 2xl:text-42 ${Tiempos.className}`}
            >
              {slide?.banner_heading}
            </Typography>
            <Typography className={`my-48 whitespace-pre-line text-20 font-normal leading-7 text-white lg:leading-10 xl:text-18 2xl:text-20 ${NationalBook.className}`}>
              {slide?.banner_description}
            </Typography>
            {slide?.ctas?.length > 0 &&
              slide?.ctas.map((ctaButton: any, index: number) => (
                <Link link={ctaButton?.button?.href} key={index}>
                  <Button className="border-1 rounded-none border border-[#2B2C39] bg-white px-25 py-13  shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4]">
                    <Typography as="span" className={`text-16 text-[#090909] xl:text-14 2xl:text-16 ${NationalSemibold.className}`}>
                      {ctaButton?.button?.title}
                    </Typography>
                  </Button>
                </Link>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WhyCaromaBanner;
